import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import VeylLogo from './VeylLogo';

export default function DisabledPage() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#13335e',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem'
    }}>
      <div style={{
        backgroundColor: '#FFFFFF',
        borderRadius: '1rem',
        padding: '2.5rem',
        maxWidth: '28rem',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div
          src={VeylLogo}
          alt="VeylLogo"
          style={{ width: '120px', objectFit: 'contain', marginBottom: '1.5rem' }}
        />

        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🚫</div>

        <h1 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1A1A1A', marginBottom: '0.75rem' }}>
          Account Disabled
        </h1>

        <p style={{ color: '#6b7280', fontSize: '0.875rem', lineHeight: '1.6', marginBottom: '2rem' }}>
          Your account has been permanently disabled due to multiple violations of our community guidelines.
          If you believe this is a mistake, please contact us at{' '}
          <a href="mailto:support@veyl.app" style={{ color: '#1B7A8A', fontWeight: '500' }}>
            support@veyl.app
          </a>
        </p>

        <button
          onClick={() => signOut(auth)}
          style={{
            width: '100%',
            padding: '0.875rem',
            backgroundColor: '#F5F5F5',
            color: '#1A1A1A',
            border: '1px solid #e5e7eb',
            borderRadius: '0.5rem',
            fontWeight: '600',
            cursor: 'pointer',
            fontSize: '0.95rem'
          }}
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}